<template>
	<v-card v-if="item">
		<v-container>
			<v-layout align-center justify-space-between wrap class="mb-2">
				<h2 class="title">Kontaktformular</h2>
				<navigation :id="item.id" />
			</v-layout>
			<p class="body-1">
				<strong>Vielen Dank für Ihre Eingabe.</strong>
			</p>
			<p class="body-1">
				Das Ergebnis der rechtlichen Prüfung sehen Sie auf der nächsten Seite.
				Dort können Sie auch die Höhe Ihrer voraussichtlichen Abfindung
				ermitteln.
			</p>
			<p class="body-1">
				Bitte nutzen Sie das folgende Online-Formular, um mit uns in Kontakt zu
				treten. Ihre Eingaben unterliegen selbstverständlich der anwaltlichen
				Schweigepflicht. Durch Ihre Anfrage kommt kein Mandatsverhältnis
				zustande.
			</p>
			<p class="body-1">
				Wir werden Sie
				<strong>kostenlos und unverbindlich</strong> kontaktieren, um das
				weitere Vorgehen mit Ihnen abzustimmen.
			</p>
			<contact-form></contact-form>
		</v-container>
	</v-card>
</template>

<script>
import ContactForm from './ContactForm.vue';
import Navigation from './Navigation.vue';

export default {
	components: {
		ContactForm,
		Navigation,
	},
	props: ['item'],
};
</script>
